import { axios } from "../utils/axios";
import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { useActasStore } from "../store/actasStore";
import { useNotificadoresStore } from "../store/notificadoresStore";
import { useActaDetalleStore } from "../store/actaDetalleStore";

const useNotificadores = () => {
  const { setNotificadores, notificadores } = useNotificadoresStore();
  const { handlerLoading, handlerModal } = useGeneralAppStore();
  const { actas, setActas, actasFilter, setActasFilter, setActaDetalle, actaDetalle } =
    useActasStore();
  const { coleccionActasDetalle, setColeccionActasDetalle, setActa, acta } = useActaDetalleStore();

  //?TREA TODO LOS NOTIFICADORES
  const getNotificadores = async () => {
    handlerLoading({ loading: true, loadName: "notificadores" });
    const response = await axios().get("/get_notificadores");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setNotificadores(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "notificadores" });
  };

  //?ASIGNA UN NOTIFICADOR A UN ACTA
  const asignarNotificador = async (dataSend) => {
    handlerLoading({ loading: true, loadName: "confirmarNotificador" });
    const response = await axios().post("/asignar_notificador", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        if (actas) {
          const newActas = actas.filter((acta) => acta.id != actaDetalle.acta.id);
          setActas(newActas);
          const newActasFilter = actasFilter.filter((acta) => acta.id != actaDetalle.acta.id);
          setActasFilter(newActasFilter);
        }

        const newActaDetalle = actaDetalle;
        newActaDetalle.acta.estado_id = 8;
        newActaDetalle.acta.estado = {
          id: 8,
          descripcion: "EN REPARTO",
        };
        const notificadorFind = notificadores.find(
          (notificador) => notificador.usuarioID == data.user_id_asignado
        );
        if (notificadorFind) {
          const persona = {
            persona: notificadorFind,
          };
          newActaDetalle.acta.notificador = [persona];
        }

        setActaDetalle(newActaDetalle);
        toast.success("Notificador asigando al acta", toastOptions);
        handlerModal({ modal: false, modalName: "notificadores" });
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "confirmarNotificador" });
  };

  //?REASIGNA UN NOTIFICADOR A UN ACTA
  const reasignarNotificador = async (dataSend,setRefetch = null) => {
    handlerLoading({ loading: true, loadName: "reasignar_notificador" });
    const response = await axios().post("/reasignar_notificador", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        let pepito = coleccionActasDetalle.map((obj) => {
          if (dataSend.actas.includes(obj.acta.id)) {
            let actita = data.actas.filter((act, index) => {
              if (act.acta.id == obj.acta.id) {
                return data.actas[index];
              }
            });
            return { acta: actita[0], archivos: obj.archivos };
          } else {
            return obj;
          }
        });
        setActa(data.actas[0].acta);
        setColeccionActasDetalle(pepito);
        data.actas;
        const newActas = actas.filter((act) => act.id != acta.id);
        setActas(newActas);
        const newActasFilter = actasFilter.filter((act) => act.id != acta.id);
        setActasFilter(newActasFilter);     
        toast.success("Notificador asigando al acta", toastOptions);
        setRefetch && setRefetch(true)
        handlerModal({ modal: false, modalName: "reasignar_notificador" });
        
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "reasignar_notificador" });
  };
  return { getNotificadores, asignarNotificador, reasignarNotificador };
};

export default useNotificadores;
